import { render, staticRenderFns } from "./transactionHistoryTab.vue?vue&type=template&id=05cb2b3a&scoped=true&"
import script from "./transactionHistoryTab.vue?vue&type=script&lang=js&"
export * from "./transactionHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb2b3a",
  null
  
)

export default component.exports